import type { ValueOf } from 'type-fest'

export const MembershipPageTab = {
  plans: 'plans',
  packs: 'packs',
} as const

export type MembershipPageTab = ValueOf<typeof MembershipPageTab>

export const MEMBERSHIP_PAGE_PATHS: Record<MembershipPageTab, string> = {
  [MembershipPageTab.plans]: '/membership/plans',
  [MembershipPageTab.packs]: '/membership/credit-packs',
}
